export const THEME_STORAGE_KEY = 'zeedcom-theme';

export const readStoredDarkMode = (): boolean | null => {
  try {
    const value = localStorage.getItem(THEME_STORAGE_KEY);
    if (value === 'dark') return true;
    if (value === 'light') return false;
  } catch {
    /* ignore */
  }
  return null;
};

export const storeDarkMode = (enabled: boolean) => {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, enabled ? 'dark' : 'light');
  } catch {
    /* ignore */
  }
};
